import { useMemo, useState } from "react";

export default function useSelecaoIntegracao(itens) {
    const [selecionados, setSelecionados] = useState([]);
    const [expandidos, setExpandidos] = useState({});

    const todosSelecionados = itens.length > 0 && itens.every((item) => selecionados.includes(item.id));
    const algumSelecionado = selecionados.length > 0 && !todosSelecionados;

    function selecionarTodos(event) {
        setSelecionados(event.target.checked ? itens.map((item) => item.id) : []);
    }

    function selecionar(id) {
        setSelecionados((old) =>
            old.includes(id) ? old.filter((x) => x !== id) : [...old, id]
        );
    }

    function expandir(id) {
        setExpandidos((old) => ({ ...old, [id]: !old[id] }));
    }

    function limpar() {
        setSelecionados([]);
        setExpandidos({});
    }

    const itensSelecionados = useMemo(
        () => itens.filter((item) => selecionados.includes(item.id)),
        [itens, selecionados]
    );

    const totalSelecionado = useMemo(
        () => itensSelecionados.reduce((soma, item) => soma + Number(item.totalFaturamento || 0), 0),
        [itensSelecionados]
    );

    return {
        selecionados,
        expandidos,
        todosSelecionados,
        algumSelecionado,
        selecionarTodos,
        selecionar,
        expandir,
        limpar,
        itensSelecionados,
        totalSelecionado
    };
}
